import type { DocumentGenerationSlice } from '@/domains/documents/store/types/DocumentGenerationSlice';

export const generateDocumentInitialState: DocumentGenerationSlice = {
  statuses: {
    isUploading: false,
    isGenerating: false,
    isOptionsLoading: false,
  },
  options: {
    claimOptions: [],
    claimantOptions: [],
  },
};
